import React from 'react';
import { Box, Checkbox, Tooltip } from '@mui/material';
import UnfoldMoreDoubleIcon from '@mui/icons-material/UnfoldMoreDouble';
import UnfoldLessDoubleIcon from '@mui/icons-material/UnfoldLessDouble';

import { StyledButton } from '@molecules/FilterButton/styles';

interface CollapseTableUtilitiesProps {
  checkedAll?: boolean;
  onCheckAll?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onExpandAll?: () => void;
  onCollapseAll?: () => void;
}

const CollapseTableUtilities: React.FC<CollapseTableUtilitiesProps> = (props) => {
  const { checkedAll, onCheckAll, onExpandAll, onCollapseAll } = props;

  const onClickCheckAll = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) =>
    e.stopPropagation();

  return (
    <Box
      sx={{
        width: 'fit-content',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '8px',
      }}
    >
      {onCheckAll && (
        <Checkbox checked={checkedAll} onChange={onCheckAll} onClick={onClickCheckAll} />
      )}
      {onExpandAll && (
        <StyledButton variant="outlined" color="black" onClick={onExpandAll}>
          <Tooltip title="Expand All">
            <UnfoldMoreDoubleIcon fontSize="small" />
          </Tooltip>
        </StyledButton>
      )}
      {onCollapseAll && (
        <StyledButton variant="outlined" color="black" onClick={onCollapseAll}>
          <Tooltip title="Collapse All">
            <UnfoldLessDoubleIcon fontSize="small" />
          </Tooltip>
        </StyledButton>
      )}
    </Box>
  );
};

export default CollapseTableUtilities;
